import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import TabNavigator from './TabNavigator';
import AddItemScreen from '../screens/AddItemScreen';
import AddAnalyzedItemScreen from '../screens/AddAnalyzedItemScreen';
import SaveSuccessScreen from '../screens/SaveSuccessScreen';
import GroupItemsScreen from '../screens/GroupItemsScreen';
import MergeDuplicatesScreen from '../screens/MergeDuplicatesScreen';
import EditExistingItemScreen from '../screens/EditExistingItemScreen';
import ItemDetailScreen from '../screens/ItemDetailScreen';
import ReanalyzeItemScreen from '../screens/ReanalyzeItemScreen';
import ReportIssueScreen from '../screens/ReportIssueScreen';
import RemoveItemScreen from '../screens/RemoveItemScreen';
import AdminReportsScreen from '../screens/AdminReportsScreen';
import AdminMarketDiagnosticsScreen from '../screens/AdminMarketDiagnosticsScreen';
import type { MainStackParamList } from '../types/navigation';

const Stack = createNativeStackNavigator<MainStackParamList>();

export default function MainNavigator() {
  return (
    <Stack.Navigator
      initialRouteName="Tabs"
      screenOptions={{
        headerShown: false, // Set default to false
      }}
    >
      <Stack.Screen
        name="Tabs"
        component={TabNavigator}
      />
      <Stack.Screen
        name="AddItem"
        component={AddItemScreen}
        options={{ 
          headerShown: false,
          gestureEnabled: true,
          fullScreenGestureEnabled: true,
        }}
      />
      <Stack.Screen
        name="AddAnalyzedItem"
        component={AddAnalyzedItemScreen}
        options={{ 
          headerShown: false,
          gestureEnabled: true,
          fullScreenGestureEnabled: true,
        }}
      />
      <Stack.Screen
        name="SaveSuccess"
        component={SaveSuccessScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name="GroupItems"
        component={GroupItemsScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name="MergeDuplicates"
        component={MergeDuplicatesScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name="EditExistingItem"
        component={EditExistingItemScreen}
        options={{ 
          headerShown: false,
          gestureEnabled: true,
          fullScreenGestureEnabled: true,
        }}
      />
      <Stack.Screen
        name="ItemDetail"
        component={ItemDetailScreen}
        options={{ 
          headerShown: false,
          gestureEnabled: true,
          fullScreenGestureEnabled: true,
        }}
      />
      <Stack.Screen
        name="ReanalyzeItem"
        component={ReanalyzeItemScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name="ReportIssue"
        component={ReportIssueScreen}
        options={{ 
          headerShown: false,
          gestureEnabled: true,
          fullScreenGestureEnabled: true,
        }}
      />
      <Stack.Screen
        name="RemoveItem"
        component={RemoveItemScreen}
        options={{ 
          headerShown: false,
          gestureEnabled: true,
          fullScreenGestureEnabled: true,
        }}
      />
      <Stack.Screen
        name="AdminReports"
        component={AdminReportsScreen}
        options={{ headerShown: true, title: 'Admin Reports' }}
      />
      <Stack.Screen
        name="AdminMarketDiagnostics"
        component={AdminMarketDiagnosticsScreen}
        options={{ headerShown: true, title: 'Market Pricing Diagnostics' }}
      />
    </Stack.Navigator>
  );
}
